import React from 'react';

export const HealthScore = ({ score, size = 'md' }) => {
  const getScoreColor = (score) => {
    if (score === null || score === undefined) return { stroke: '#94A3B8', bg: 'bg-slate-50', text: 'text-slate-500', label: 'N/A' };
    if (score >= 80) return { stroke: '#5DBDB3', bg: 'bg-[#5DBDB3]/10', text: 'text-[#5DBDB3]', label: 'Excellent' };
    if (score >= 60) return { stroke: '#22C55E', bg: 'bg-green-50', text: 'text-green-600', label: 'Good' };
    if (score >= 40) return { stroke: '#F59E0B', bg: 'bg-amber-50', text: 'text-amber-600', label: 'Moderate' };
    if (score >= 20) return { stroke: '#F08B7D', bg: 'bg-[#F08B7D]/10', text: 'text-[#F08B7D]', label: 'Poor' };
    return { stroke: '#EF4444', bg: 'bg-red-50', text: 'text-red-600', label: 'Avoid' };
  };

  const colors = getScoreColor(score);
  const displayScore = score !== null && score !== undefined ? score : '?';
  
  const sizes = {
    sm: { container: 'w-16 h-16', stroke: 4, font: 'text-sm', labelFont: 'text-xs' },
    md: { container: 'w-24 h-24', stroke: 6, font: 'text-xl', labelFont: 'text-xs' },
    lg: { container: 'w-32 h-32', stroke: 8, font: 'text-3xl', labelFont: 'text-sm' },
  };
  
  const sizeConfig = sizes[size];
  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const progress = score !== null && score !== undefined 
    ? ((100 - score) / 100) * circumference 
    : circumference; // Show empty ring if no score

  return (
    <div className="flex flex-col items-center gap-2" data-testid="health-score">
      <div className={`relative ${sizeConfig.container}`}>
        <svg className="w-full h-full transform -rotate-90" viewBox="0 0 100 100">
          {/* Background circle */}
          <circle
            cx="50"
            cy="50"
            r={radius}
            fill="none"
            stroke="#E2E8F0"
            strokeWidth={sizeConfig.stroke}
          />
          {/* Progress circle */}
          <circle
            cx="50"
            cy="50"
            r={radius}
            fill="none"
            stroke={colors.stroke}
            strokeWidth={sizeConfig.stroke}
            strokeDasharray={circumference}
            strokeDashoffset={progress}
            strokeLinecap="round"
            className="score-ring"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className={`font-bold ${sizeConfig.font} ${colors.text}`} data-testid="health-score-value">
            {displayScore}
          </span>
        </div>
      </div>
      <span className={`font-medium ${sizeConfig.labelFont} ${colors.text}`} data-testid="health-score-label">
        {colors.label}
      </span>
    </div>
  );
};

export default HealthScore;
